export default __webpack_public_path__ + "static/media/Image2.bee918a1.jpeg";